import { atom } from 'recoil';

import { DEFAULT_LANGUAGE, ILanguage } from 'shared/utils/i18next-config';

export const currentLanguageAtom = atom<ILanguage>({
    key: 'currentLanguageAtom',
    default: DEFAULT_LANGUAGE,
});
